import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

interface SliderSwiperProps {
    el: HTMLElement;
}

const Slider = ({ el }: SliderSwiperProps): void => {
    const sliderSwiper = new Swiper(el, {
        init: false,
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    sliderSwiper.init();
};

export default Slider;
